module.exports = __webpack_public_path__ + "c1c47874ff0c277258a3f994ea73f3f6.pdf";